import { MediaCallOperateCode } from '@halo/chat-sdk-react';
import { toaster } from '@halo/ui-react';

export const useMediaError = () => {
  const { t } = useTranslation();

  const mediaError = useCallback(
    (error: { code: MediaCallOperateCode }, type: 'call' | 'invite') => {
      if (error?.code === MediaCallOperateCode.USER_BUSY) {
        toaster.error({ title: t('tips.userBusyLine') });
      } else if (error?.code === MediaCallOperateCode.SELF_IN_CALL) {
        toaster.error({ title: t('tips.youAreCalling') });
      } else if (error?.code === MediaCallOperateCode.PRIVACY_BLOCK_CALL) {
        toaster.error({ title: t('tips.privacyBlockCall') });
      } else {
        toaster.error({ title: type === 'call' ? t('tips.callFailed') : t('tips.inviteFailed') });
      }
    },
    [t]
  );
  return { mediaError };
};
